module.exports = __webpack_public_path__ + "media/images/instructions/3-eb6ef3dea4faebdbfeb2a23354a880e5.png";